<template>
    <Panel :key="setup.id" size="full" :borderColor="selected ? 'bg-red-600' : 'bg-zync-700'">
        <div @click="cardClick" class="cursor-pointer" data-testid="setup-card">
            <div class="flex justify-between">
                <div>
                    <h3
                        class="font-title col-span-3 line-clamp-2 text-xl leading-8 font-extrabold text-ellipsis uppercase"
                    >
                        {{ setup.name }}
                    </h3>
                    <div class="text-titles mt-2 mb-4 text-base whitespace-nowrap">
                        <div>{{ $t('setup_card.created_on') }}</div>
                        <div class="font-bold">{{ formattedCreatedAt }}</div>
                    </div>
                </div>
                <div class="absolute right-0 mr-3 max-w-[150px]">
                    <SetupImage :setup="setup.number" />
                </div>
            </div>
            <div class="grid flex-1 grid-cols-3 gap-6">
                <div class="flex flex-col gap-2">
                    <p class="text-sm">{{ $t('setup_card.games') }}</p>
                    <div class="text-md font-bold">{{ stats?.games_played || 0 }}</div>
                </div>
                <div class="flex flex-col gap-2">
                    <p class="text-sm">{{ $t('setup_card.winrate') }}</p>
                    <div class="text-md font-bold">
                        {{ stats?.winrate ? Math.floor(stats.winrate) + '%' : '0%' }}
                    </div>
                </div>
                <div class="flex flex-col gap-2">
                    <p class="text-sm">{{ $t('setup_card.avg') }}</p>
                    <div class="text-md font-bold">
                        {{ stats?.average ? Math.floor(stats.average * 100) / 100 : 0 }}
                    </div>
                </div>
            </div>
        </div>
    </Panel>
</template>

<script>
import Panel from '@/components/layout/Panel.vue'
import SetupImage from '@/components/ui/setups/SetupImage.vue'

export default {
    name: 'SetupCard',
    components: {
        Panel,
        SetupImage,
    },
    props: {
        setup: {
            type: Object,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        setupStats: {
            type: Object,
            required: true,
        },
        selectedGameType: {
            type: String,
            default: null,
        },
    },
    emits: ['edit', 'delete', 'selected'],
    computed: {
        formattedCreatedAt() {
            if (!this.setup.created_at) return ''
            const date = new Date(this.setup.created_at)
            return date.toLocaleDateString('nl-NL', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            })
        },
        stats() {
            if (!this.selectedGameType) {
                const allStats = this.setupStats[this.setup.id]
                if (!allStats) return null
                const gameTypes = Object.keys(allStats)
                if (gameTypes.length === 0) return null
                return allStats[gameTypes[0]]
            }
            return this.setupStats[this.setup.id]?.[this.selectedGameType]
        },
    },
    methods: {
        viewDetail() {
            this.$router.push({ name: 'setup-detail', params: { id: this.setup.id } })
        },
        cardClick() {
            console.log('Card clicked for setup:', this.setup)
            this.$emit('selected', this.setup)
        },
    },
}
</script>
